const enDomain = {
  "en-v-ls.comfortweather.com": {
    shortDate: "DD/MM",
    longDate: "DD/MM/YYYY",
  },
  "en-mils.comfortweather.com": {
    shortDate: "DD/MM",
    longDate: "DD/MM/YYYY",
  },
  "en-wg.comfortweather.com": {
    shortDate: "DD/MM",
    longDate: "DD/MM/YYYY",
  },
  "mos.comfortweather.com": {
    shortDate: "DD/MM",
    longDate: "DD/MM/YYYY",
  },
  "en-miwg.comfortweather.com": {
    shortDate: "DD/MM",
    longDate: "DD/MM/YYYY",
  },
  "default.comfortweather.com": {
    shortDate: "DD/MM",
    longDate: "DD/MM/YYYY",
  },
  "en-mxwg.comfortweather.com": {
    shortDate: "DD/MM",
    longDate: "DD/MM/YYYY",
  },
  // "en.comfortweather.com": {
  //   shortDate: "DD/MM",
  //   longDate: "DD/MM/YYYY",
  // },
};
const domainToDateFormatMap: any = {
  // 英语相关域名
  ...enDomain,
  // 印尼语相关
  "id-mils.comfortweather.com": {
    shortDate: "DD/MM",
    longDate: "DD/MM/YYYY",
  },
  "id-miwg.comfortweather.com": {
    shortDate: "DD/MM",
    longDate: "DD/MM/YYYY",
  },
  "id-v-ls.comfortweather.com": {
    shortDate: "DD/MM",
    longDate: "DD/MM/YYYY",
  },
  "id-wg.comfortweather.com": {
    shortDate: "DD/MM",
    longDate: "DD/MM/YYYY",
  },
  "id-wi.comfortweather.com": {
    shortDate: "DD/MM",
    longDate: "DD/MM/YYYY",
  },
  "id.comfortweather.com": {
    shortDate: "DD/MM",
    longDate: "DD/MM/YYYY",
  },
  // 西班牙语相关
  "es-mils.comfortweather.com": {
    shortDate: "DD/MM",
    longDate: "DD/MM/YYYY",
  },
  "es-wg.comfortweather.com": {
    shortDate: "DD/MM",
    longDate: "DD/MM/YYYY",
  },
  "pt-br-wg.comfortweather.com": {
    shortDate: "DD/MM",
    longDate: "DD/MM/YYYY",
  },
  "es-wi.comfortweather.com": {
    shortDate: "DD/MM",
    longDate: "DD/MM/YYYY",
  },
  "es-mxwg.comfortweather.com": {
    shortDate: "DD/MM",
    longDate: "DD/MM/YYYY",
  },
  "es.comfortweather.com": {
    shortDate: "DD/MM",
    longDate: "DD/MM/YYYY",
  },
  // 塞尔维亚语
  "sr-mils.comfortweather.com": {
    shortDate: "DD/MM",
    longDate: "DD/MM/YYYY",
  },
  // 保加利亚语
  "bg-mils.comfortweather.com": {
    shortDate: "DD/MM",
    longDate: "DD/MM/YYYY",
  },
  // 斯洛伐克语
  "sk-mils.comfortweather.com": {
    shortDate: "DD/MM",
    longDate: "DD/MM/YYYY",
  },
  // 捷克语
  "cs-mils.comfortweather.com": {
    shortDate: "DD/MM",
    longDate: "DD/MM/YYYY",
  },
  // 希腊语
  "el-mils.comfortweather.com": {
    shortDate: "DD/MM",
    longDate: "DD/MM/YYYY",
  },
  // 希伯来语
  "he-mils.comfortweather.com": {
    shortDate: "DD/MM",
    longDate: "DD/MM/YYYY",
  },
  // 乌克兰语
  "uk-mils.comfortweather.com": {
    shortDate: "DD/MM",
    longDate: "DD/MM/YYYY",
  },
  // 俄语
  "ru-mils.comfortweather.com": {
    shortDate: "DD/MM",
    longDate: "DD/MM/YYYY",
  },
  "rs-mils.comfortweather.com": {
    shortDate: "DD/MM",
    longDate: "DD/MM/YYYY",
  },
  // 小部件的俄罗斯域名新增域名
  "rs-wg.comfortweather.com": {
    shortDate: "DD/MM",
    longDate: "DD/MM/YYYY",
  },
  // go机型新增单独俄罗斯的子域名
  "rs-miwg.comfortweather.com": {
    shortDate: "DD/MM",
    longDate: "DD/MM/YYYY",
  },

  // 阿塞拜疆语
  "az-mils.comfortweather.com": {
    shortDate: "DD/MM",
    longDate: "DD/MM/YYYY",
  },
};

function replacePatternInDateFormat(dateFormat: string, pattern: string): string {
  return dateFormat.replace(/\//g, pattern);
}

export default function useDateFormat(pattern = "/") {
  const { subdomain } = useSubdomain();
  const currentHostname = window.location.hostname;
  const domainConfig = useMemo(() => {
    return (
      domainToDateFormatMap[currentHostname] ||
      domainToDateFormatMap[`${subdomain}.comfortweather.com`] || { shortDate: "MM/DD", longDate: "YYYY/MM/DD" }
    );
  }, [currentHostname, subdomain]);

  const formattedDateFormats = useMemo(
    () => ({
      shortDate: replacePatternInDateFormat(domainConfig.shortDate, pattern),
      longDate: replacePatternInDateFormat(domainConfig.longDate, pattern),
    }),
    [domainConfig, pattern],
  );

  return {
    ...formattedDateFormats,
    supportedDomains: Object.keys(domainToDateFormatMap),
    enDomains: Object.keys(enDomain),
  };
}

// 印地语相关
// export const hi_domain = ["hi-v-ls.comfortweather.com", "hi-miwg.comfortweather.com", "hi-wg.comfortweather.com", "hi.comfortweather.com"];
